import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { CATERING_PATH } from 'catering/constants/paths';
import {
  AccountProvider,
  GoogleApiProvider,
  NotificationModalProvider,
  ThemeProvider
} from 'catering/context/providers';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      useErrorBoundary: false
    }
  }
});

function CateringProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <Router basename={CATERING_PATH}>
        <AccountProvider>
          <ThemeProvider>
            <GoogleApiProvider>
              <NotificationModalProvider>{children}</NotificationModalProvider>
            </GoogleApiProvider>
          </ThemeProvider>
        </AccountProvider>
      </Router>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

CateringProviders.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired
};

export default CateringProviders;
